import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SettingsPage: React.FC = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(() => {
        if (location.pathname.includes('billing')) return 'billing';
        if (location.pathname.includes('api')) return 'api';
        if (location.pathname.includes('team')) return 'team';
        return 'account';
    });

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Einstellungen</h1>

            <div className="bg-white shadow rounded-lg overflow-hidden">
                <div className="sm:hidden">
                    <label htmlFor="tabs" className="sr-only">Kategorie wählen</label>
                    <select
                        id="tabs"
                        name="tabs"
                        className="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
                        value={activeTab}
                        onChange={(e) => setActiveTab(e.target.value)}
                    >
                        <option value="account">Account</option>
                        <option value="billing">Abrechnung</option>
                        <option value="team">Team</option>
                        <option value="api">API</option>
                    </select>
                </div>
                <div className="hidden sm:block">
                    <div className="border-b border-gray-200">
                        <nav className="-mb-px flex" aria-label="Tabs">
                            <button
                                onClick={() => setActiveTab('account')}
                                className={`${
                                    activeTab === 'account'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm`}
                            >
                                Account
                            </button>
                            <button
                                onClick={() => setActiveTab('billing')}
                                className={`${
                                    activeTab === 'billing'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm`}
                            >
                                Abrechnung
                            </button>
                            <button
                                onClick={() => setActiveTab('team')}
                                className={`${
                                    activeTab === 'team'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm`}
                            >
                                Team
                            </button>
                            <button
                                onClick={() => setActiveTab('api')}
                                className={`${
                                    activeTab === 'api'
                                        ? 'border-blue-500 text-blue-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm`}
                            >
                                API
                            </button>
                        </nav>
                    </div>
                </div>

                <div className="p-6">
                    {activeTab === 'account' && (
                        <div>
                            <h2 className="text-xl font-medium text-gray-900 mb-4">Account-Einstellungen</h2>

                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Persönliche Informationen</h3>
                                    <p className="mt-1 text-sm text-gray-500">Aktualisiere deine persönlichen Daten und E-Mail-Adresse.</p>
                                    <Link to="/profile" className="mt-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                                        Profil bearbeiten
                                    </Link>
                                </div>

                                <hr className="border-gray-200" />

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Passwort</h3>
                                    <p className="mt-1 text-sm text-gray-500">Stelle sicher, dass dein Account ein sicheres Passwort verwendet.</p>
                                    <button className="mt-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                                        Passwort ändern
                                    </button>
                                </div>

                                <hr className="border-gray-200" />

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Zwei-Faktor-Authentifizierung</h3>
                                    <p className="mt-1 text-sm text-gray-500">Füge eine zusätzliche Sicherheitsebene für deinen Account hinzu.</p>
                                    <div className="mt-3">
                                        <button className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600">
                                            Zwei-Faktor-Authentifizierung aktivieren
                                        </button>
                                    </div>
                                </div>

                                <hr className="border-gray-200" />

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900 text-red-600">Gefahrenbereich</h3>
                                    <p className="mt-1 text-sm text-gray-500">Wenn du deinen Account löschst, werden alle deine Daten und Chatbots dauerhaft entfernt.</p>
                                    <button className="mt-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-500 hover:bg-red-600">
                                        Account löschen
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'billing' && (
                        <div>
                            <h2 className="text-xl font-medium text-gray-900 mb-4">Abrechnung</h2>

                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Aktueller Plan</h3>
                                    <div className="mt-3 p-4 bg-blue-50 rounded-lg">
                                        <div className="flex justify-between items-center">
                                            <div>
                                                <h4 className="text-md font-semibold text-blue-800">Premium Plan</h4>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    €49,00 / Monat
                                                </p>
                                                <div className="flex items-center mt-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                    </svg>
                                                    <span className="ml-1 text-sm text-gray-600">Nächste Abrechnung: 15.06.2025</span>
                                                </div>
                                            </div>
                                            <button className="px-3 py-1 border border-blue-500 text-blue-500 rounded-md text-sm hover:bg-blue-50">
                                                Plan ändern
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Zahlungsmethoden</h3>
                                    <div className="mt-3 border border-gray-200 rounded-md p-4">
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                                </svg>
                                                <div className="ml-3">
                                                    <p className="text-sm font-medium text-gray-900">Visa endend auf 1234</p>
                                                    <p className="text-sm text-gray-500">Läuft ab: 12/2026</p>
                                                </div>
                                            </div>
                                            <button className="text-sm text-gray-500 hover:text-gray-700">Bearbeiten</button>
                                        </div>
                                    </div>
                                    <button className="mt-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                                        Zahlungsmethode hinzufügen
                                    </button>
                                </div>

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Rechnungen</h3>
                                    <div className="mt-3 overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                                        <table className="min-w-full divide-y divide-gray-300">
                                            <thead className="bg-gray-50">
                                            <tr>
                                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">Datum</th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Betreff</th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Betrag</th>
                                                <th scope="col" className="relative py-3.5 pl-3 pr-4">
                                                    <span className="sr-only">Herunterladen</span>
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody className="bg-white">
                                            <tr>
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">01.05.2025</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Premium Plan - Mai 2025</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">€49,00</td>
                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium">
                                                    <a href="#" className="text-blue-600 hover:text-blue-900">Herunterladen</a>
                                                </td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">01.04.2025</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">Premium Plan - April 2025</td>
                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">€49,00</td>
                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium">
                                                    <a href="#" className="text-blue-600 hover:text-blue-900">Herunterladen</a>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'team' && (
                        <div>
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-medium text-gray-900">Team-Mitglieder</h2>
                                <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
                                    Mitglied hinzufügen
                                </button>
                            </div>

                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">Name</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">E-Mail</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Rolle</th>
                                        <th scope="col" className="relative py-3.5 pl-3 pr-4">
                                            <span className="sr-only">Bearbeiten</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white">
                                    <tr>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            <div className="flex items-center">
                                                <img className="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
                                                <div className="ml-3">Benedikt Beumker</div>
                                            </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">benedikt@example.com</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                          Administrator
                        </span>
                                        </td>
                                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium">
                                            <a href="#" className="text-blue-600 hover:text-blue-900">Bearbeiten</a>
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-50">
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                                            <div className="flex items-center">
                                                <img className="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
                                                <div className="ml-3">Lisa Schmidt</div>
                                            </div>
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">lisa@example.com</td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                          Mitglied
                        </span>
                                        </td>
                                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium">
                                            <a href="#" className="text-blue-600 hover:text-blue-900">Bearbeiten</a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-3">Ausstehende Einladungen</h3>
                                <div className="bg-white rounded-md border border-gray-200 p-4">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <p className="font-medium text-gray-900">max@example.com</p>
                                            <p className="text-sm text-gray-500 mt-1">Eingeladen am: 05.05.2025</p>
                                        </div>
                                        <button className="text-sm text-red-600 hover:text-red-800">
                                            Einladung zurückziehen
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'api' && (
                        <div>
                            <h2 className="text-xl font-medium text-gray-900 mb-4">API-Einstellungen</h2>

                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">API-Schlüssel</h3>
                                    <p className="mt-1 text-sm text-gray-500">Verwende diese Schlüssel, um API-Anfragen von deinen Anwendungen zu authentifizieren.</p>

                                    <div className="mt-3">
                                        <label htmlFor="api-key" className="block text-sm font-medium text-gray-700">Dein API-Schlüssel</label>
                                        <div className="mt-1 flex rounded-md shadow-sm">
                                            <input
                                                type="text"
                                                readOnly
                                                name="api-key"
                                                id="api-key"
                                                className="flex-1 min-w-0 block w-full px-3 py-2 rounded-l-md border border-gray-300 bg-gray-50"
                                                value="sk_test_12345abcdef6789"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    navigator.clipboard.writeText('sk_test_12345abcdef6789');
                                                    alert('API-Schlüssel in die Zwischenablage kopiert!');
                                                }}
                                                className="inline-flex items-center px-3 py-2 border border-l-0 border-gray-300 bg-gray-50 text-gray-500 rounded-r-md hover:bg-gray-100"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                    <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
                                                    <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="mt-3 flex space-x-3">
                                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
                                            Neuen Schlüssel generieren
                                        </button>
                                        <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
                                            Schlüssel zurücksetzen
                                        </button>
                                    </div>
                                </div>

                                <hr className="border-gray-200" />

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">Webhook-Endpunkte</h3>
                                    <p className="mt-1 text-sm text-gray-500">Konfiguriere URLs, um Benachrichtigungen über Ereignisse zu erhalten.</p>

                                    <div className="mt-3">
                                        <div className="bg-white rounded-md border border-gray-200 p-4 mb-3">
                                            <div className="flex justify-between items-center">
                                                <div>
                                                    <p className="font-medium text-gray-900">https://example.com/webhook</p>
                                                    <p className="text-sm text-gray-500 mt-1">Aktive Ereignisse: chat.started, chat.ended</p>
                                                </div>
                                                <button className="text-sm text-red-600 hover:text-red-800">
                                                    Entfernen
                                                </button>
                                            </div>
                                        </div>

                                        <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
                                            Webhook-Endpunkt hinzufügen
                                        </button>
                                    </div>
                                </div>

                                <hr className="border-gray-200" />

                                <div>
                                    <h3 className="text-lg font-medium text-gray-900">API-Dokumentation</h3>
                                    <p className="mt-1 text-sm text-gray-500">Erfahre, wie du unsere API zur Integration in deine Anwendungen verwenden kannst.</p>
                                    <div className="mt-3">
                                        <a href="#" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600">
                                            API-Dokumentation ansehen
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;